module.exports = __webpack_public_path__ + "img/finland-infectious-diseases-male.18a7f96e.png";